import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import images from "../../assets/images";
import { getAgreements } from "../../redux/homepage/saga";
import { AgreementDto } from "../../redux/homepage/type";
import { getLocalization } from "../../redux/localization";
import FooterTop from "./footerTop";
import { languageSelector } from "../../redux/languages";

const Footer = () => {
  const t = useSelector(getLocalization);
  const [contracts, setContracts] = useState<AgreementDto[]>([]);
  const dispatch = useDispatch();
  const lang = window.location.pathname.split("/")[1];
  const language = useSelector(languageSelector);
  const footerdata = [
    {
      title: t.getString("SITEMAP"),
      subitems: [
        {
          content: "Home",
          path: "/",
        },
        {
          content: t.getString("Specification"),
          path: "/solutions",
        },
        {
          content: t.getString("Pricing"),
          path: "/pricing",
        },
        {
          content: t.getString("Contact Us"),
          path: "/contact-us",
        },
      ],
    },
  ];
  useEffect(() => {
    dispatch(
      getAgreements({
        payload: {
          onSuccess: (message, payload) => setContracts(payload),
          onError: () => {},
        },
      })
    );
  }, [dispatch]);
  return (
    <React.Fragment>
      <FooterTop />
      <footer className="footerComp ">
        <Container>
          <Row>
            <Col md={4}>
              <h4>{t.getString("About")}</h4>
              <h5>
                {t.getString(
                  "If you are looking for a useful and very detailed program where you can check availability of your vehicles follow up income and expenses you can benefit from Rentificial Software"
                )}
              </h5>
            </Col>
            <Col md={2} className="emptyCol">
            <h6>BLOGS</h6>
            <ol>
               
                    <li>
                      <a href={"/blogs/freemium-car-rental-software/" }>How to Choose the Best Car Rental Software</a>
                    </li>
                  
                
              </ol>
            </Col>
            <Col md={2}>
              <h6>{t.getString("CONTRACTS")}</h6>
              <ol>
                {contracts.map((x) => {
                  const lng = language.Code.split("-")[0];
                  return (
                    <li>
                      <a href={"/agreements/" + x.Id}>{x.Title}</a>
                    </li>
                  );
                })}
              </ol>
            </Col>
            {footerdata.map((x) => (
              <Col md={2}>
                <h6>{x.title}</h6>
                <ol>
                  {/* {x.subitems.map((subitem) => {
                    const lng = language.Code.split("-")[0];
                    return (
                      <li>
                        <a href={"/" + subitem.path}>{subitem.content}</a>
                      </li>
                    );
                  })} */}
                    <li>
                      <a href={"https://www.rentificial.com/" }>Home</a>
                    </li>
                    <li>
                      <a href={"https://www.rentificial.com/solutions/" }>Solutions</a>
                    </li>
                    <li>
                      <a href={"https://www.rentificial.com/features/" }>Features</a>
                    </li>
                    <li>
                      <a href={"https://www.rentificial.com/pricing/" }>Pricing</a>
                    </li>
                    <li>
                      <a href={"https://www.rentificial.com/help/" }>Help</a>
                    </li>
                </ol>
              </Col>
            ))}
            <Col md={2} className="d-flex flex-column align-items-end">
              {/* <h6>Uyguna Kirala</h6>

              <a
                className="footerButton"
                target="_blank"
                rel={"noreferrer"}
                href="https://play.google.com/store/apps/details?id=com.rentificial"
              >
                <AiOutlineAndroid />
                {t.getString("Download")}
              </a>
              <a
                className="footerButton"
                target="_blank"
                rel={"noreferrer"}
                href="https://apps.apple.com/app/id1502714752"
              >
                <AiOutlineApple /> {t.getString("Download")}
              </a> */}
              <img src={images.iyzico} width={100} alt="Rentificial İyzico" />
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};
export default Footer;
